import { useEffect, useState } from "react";
import "./HomeAds.css";
import { publicAds } from "./partnerApi";

const TYPES = { hotel: "🏨 Hotel", cottage: "🏡 Cottage", vehicle: "🚗 Vehicle", homestay: "🏠 Homestay", resort: "🌴 Resort", other: "📦" };
const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

function HomeAdCard({ ad }) {
  const [idx, setIdx] = useState(0);
  const photos = ad.photos?.length ? ad.photos : [];
  const wa = (ad.contactWhatsapp || ad.contactPhone || "").replace(/\D/g, "");
  const go = (d) => setIdx((idx + d + photos.length) % photos.length);
  return (
    <article className="ha-card">
      <div className="ha-media">
        {photos.length > 0 ? <img src={photos[idx]} alt={ad.title} loading="lazy" /> : <div className="ha-noimg">No photo</div>}
        {photos.length > 1 && (
          <>
            <button className="ha-nav prev" onClick={() => go(-1)} aria-label="Previous">‹</button>
            <button className="ha-nav next" onClick={() => go(1)} aria-label="Next">›</button>
            <span className="ha-count">📷 {idx + 1}/{photos.length}</span>
            <div className="ha-dots">{photos.map((_, i) => <span key={i} className={i === idx ? "on" : ""} onClick={() => setIdx(i)} />)}</div>
          </>
        )}
        {ad.featured && <span className="ha-featured">⭐ Featured</span>}
        <span className="ha-type">{TYPES[ad.businessType] || ad.businessType}</span>
      </div>
      {photos.length > 1 && (
        <div className="ha-strip">
          {photos.slice(0, 6).map((u, i) => (
            <button key={i} className={`ha-thumb${i === idx ? " on" : ""}`} onClick={() => setIdx(i)}>
              <img src={u} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      )}
      <div className="ha-body">
        <h3>{ad.title}</h3>
        {ad.location && <p className="ha-loc">📍 {ad.location}</p>}
        {ad.amenities?.length > 0 && (
          <ul className="ha-amen">{ad.amenities.slice(0, 3).map((a, i) => <li key={i}>{a}</li>)}</ul>
        )}
        <div className="ha-foot">
          {ad.priceFrom > 0 && <span className="ha-price">{inr(ad.priceFrom)} <small>{ad.priceUnit}</small></span>}
          {wa
            ? <a className="ha-btn" href={`https://wa.me/91${wa}?text=${encodeURIComponent(`Hi, I'm interested in "${ad.title}" on OotyGo.`)}`} target="_blank" rel="noopener noreferrer">💬 Enquire</a>
            : ad.contactPhone && <a className="ha-btn" href={`tel:${ad.contactPhone}`}>📞 Call</a>}
        </div>
      </div>
    </article>
  );
}

export default function HomeAds() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    publicAds().then((d) => setAds((d || []).slice(0, 8))).catch(() => setAds([]));
  }, []);

  if (ads.length === 0) return null; // don't show the section until there are listings

  return (
    <section className="ha-section" id="partner-ads">
      <div className="ha-head">
        <span className="section-eyebrow">Partner Listings</span>
        <h2>Featured Stays &amp; Rides</h2>
        <p>Verified hotels, cottages, homestays &amp; vehicles from our local partners.</p>
      </div>

      <div className="ha-grid">
        {ads.map((ad) => <HomeAdCard key={ad.id} ad={ad} />)}
      </div>

      <div className="ha-more">
        <a href="/listings" className="ha-more-btn">View all listings →</a>
        <a href="/partner" className="ha-list-link">List your property</a>
      </div>
    </section>
  );
}
